import { Link } from "react-router-dom";
import { useContent } from "@/context/ContentContext";
import Brand from "@/components/site/Brand";

export default function Footer() {
  const { content } = useContent();
  const site = content.site || {};
  const nav = content.nav || [];
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#1a1a1a] text-[#f9f8f6] py-16 md:py-24"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <Brand light size="md" />
            <p className="mt-8 max-w-md text-[#f9f8f6]/70 text-sm leading-relaxed font-light">
              Karkasinių pirčių statyba Klaipėdoje ir Klaipėdos rajone. Standartinių modelių pirtys iš katalogo – idėja, projektas ir įgyvendinimas iš tų pačių rankų.
              {" "}{site.city}, {site.country}.
            </p>
          </div>
          <div className="md:col-span-3">
            <div className="overline text-[#f9f8f6]/70">Navigacija</div>
            <div className="mt-5 space-y-3 text-sm font-light">
              {nav.map((l) => (
                <Link
                  key={l.to}
                  to={l.to}
                  className="block hover:text-[#a66e4b]"
                >
                  {l.label}
                </Link>
              ))}
            </div>
          </div>
          <div className="md:col-span-4">
            <div className="overline text-[#f9f8f6]/70">Kontaktai</div>
            <div className="mt-5 space-y-2 text-sm font-light">
              <a
                href={`mailto:${site.email}`}
                className="block hover:text-[#a66e4b]"
              >
                {site.email}
              </a>
              <a
                href={`tel:${site.phoneHref}`}
                className="block hover:text-[#a66e4b]"
              >
                {site.phone}
              </a>
              <div>{site.city}, {site.country}</div>
            </div>
            <div className="mt-6 flex gap-5 text-sm">
              <a
                href={site.instagram}
                target="_blank"
                rel="noreferrer"
                className="hover:text-[#a66e4b]"
              >
                Instagram
              </a>
              <a
                href={site.facebook}
                target="_blank"
                rel="noreferrer"
                className="hover:text-[#a66e4b]"
              >
                Facebook
              </a>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-[#f9f8f6]/15 flex flex-col md:flex-row gap-4 md:items-center md:justify-between text-xs text-[#f9f8f6]/60 font-light">
          <div>© {new Date().getFullYear()} {site.brand}. Visos teisės saugomos.</div>
          <div className="tracking-[0.22em] uppercase text-[10px]">
            {site.city} · {site.country}
          </div>
        </div>
      </div>
    </footer>
  );
}
